import * as types from './types';
import socketBuilder from '~/services/socketioService';
import { getTenant } from '~/services/multiTenant';

export const closeSocketConnection = (dispatch) => {
  dispatch({
    type: types.CLOSE_SOCKET_CONNECTION,
    payload: true,
  });
};

export const newMessage = (newMessageText, type = 'sended') => (dispatch) => {
  dispatch({
    type: types.RECEIVE_NEW_MESSAGE,
    payload: {
      ...newMessageText,
      type,
      id: newMessageText.id || new Date().getTime(),
      sender: {
        web_user_id: newMessageText.sender.web_user_id,
        operator_name: newMessageText.sender.operator_name,
        room: newMessageText.sender.room,
      },
    },
  });
};

export const setConnectionStatus = connections => (dispatch) => {
  dispatch({
    type: types.SET_CONNECTION_STATUS,
    payload: connections,
  });
};

export const readChat = room => (dispatch) => {
  dispatch({
    type: types.READ_CHAT,
    payload: room,
  });
};

export const saveChatNotification = body => (dispatch) => {
  try {
    // Notification signature
    // const message = {
    //   id: 1,
    //   type: 'chat',
    //   title: `Equipamento: ${body.sender.room} enviou mensagem`,
    //   read: false,
    //   timestamp: '2025-06-20T18:30:00Z',
    // };
    const message = {
      ...body,
      title: `Equipamento: ${body.equip_id} enviou mensagem`,
    };

    dispatch({
      type: types.SET_CHAT_NOTIFICATION,
      payload: message,
    });
  } catch (err) {
    console.error('[Socket] Error handling chat_notifications:', err);
  }
};

export const readNotification = body => (dispatch) => {
  dispatch({
    type: types.MARK_AS_READ,
    payload: body,
  });
};

export const readAllNotifications = body => (dispatch) => {
  dispatch({
    type: types.MARK_ALL_AS_READ,
    payload: body,
  });
};

export const setDispatchNotifications = body => (dispatch) => {
  try {
    const message = body;
    dispatch({
      type: types.SET_CHAT_NOTIFICATION,
      payload: message,
    });
  } catch (err) {
    console.error('[Socket] Error handling chat_notifications:', err);
  }
};

export const saveChatNotificationHistory = body => (dispatch) => {
  const history = body.map(b => ({
    ...b,
    title: `Equipamento: ${b.equip_id} enviou mensagem`,
  }));

  dispatch({
    type: types.SET_CHAT_NOTIFICATION_HISTORY,
    payload: history,
  });
};

export const setSocketConnection = () => (dispatch, getState) => {
  const { token } = getState().auth.user || {};
  if (!token) return;

  const tenant = getTenant();
  const socket = socketBuilder(token, `/${tenant}/chat`);

  if (!socket) return;

  socket.on('connect', () => {
    console.log(true, 'connected');
  });

  socket.on('disconnect', () => {
    console.log(false, 'disconnected');
  });

  socket.on('platform_message', (body) => {
    dispatch(newMessage(body, body.tablet ? 'received' : 'sended'));
  });
  socket.on('chat_notifications', (body) => {
    dispatch(saveChatNotification(body));
  });
  socket.on('chat_notifications_history', (body) => {
    dispatch(saveChatNotificationHistory(body));
  });
  socket.on('dispatch_events_notification', (body) => {
    dispatch(setDispatchNotifications(body));
  });
  socket.on('connected_equipments', (body) => {
    dispatch(setConnectionStatus(body));
  });

  socket.on('history', (body) => {
    if (!(body instanceof ArrayBuffer) || body.byteLength === 0) {
      return;
    }
    const parsedHistory = JSON.parse(new TextDecoder().decode(body));
    dispatch({
      type: types.SET_CHAT_HISTORY,
      payload: { room: parsedHistory[0].sender.room, history: parsedHistory },
    });
  });

  dispatch({
    type: types.SET_SOCKET_CONNECTION,
    payload: socket,
  });
};
